/**
 * The base url host which can be used to compose api urls.
 *
 * @return {string} api host string
 */
import Config from '@/config.loader'
function urlBaseCoreAPI() {
    const host =
        Config.getConfigValue('VUE_APP_API_BASE_CORE_API') || `//${window.location.hostname}`
    const portString = process.env.VUE_APP_API_PORT ? `:${process.env.VUE_APP_API_PORT}` : ''
    return `${host}${portString}`
}

function urlBaseAppOrdit() {
    const host =
        Config.getConfigValue('VUE_APP_API_BASE_APP_ORDIT') || `//${window.location.hostname}`
    const portString = process.env.VUE_APP_API_PORT ? `:${process.env.VUE_APP_API_PORT}` : ''
    return `${host}${portString}`
}

export { urlBaseCoreAPI, urlBaseAppOrdit }
